import { render, staticRenderFns } from "./WpNavi.vue?vue&type=template&id=b0459eae"
import script from "./WpNavi.vue?vue&type=script&lang=js"
export * from "./WpNavi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports